import { getIdType } from './getIdType';

export function isImmutableId(id: string): boolean {
    return (
        getIdType(id) === 'ConcatenatedImmutableId' || getIdType(id) === 'StoreObjectImmutableId'
    );
}
